// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3lJgQ","image":"Header_image__3xVB9","name":"Header_name__2S1FQ","info":"Header_info__1Uvsh","infoRow":"Header_infoRow__2AZif"};